import { BasicCalendar, type BasicCalendarProps } from '@/components/basicCalendar/BasicCalendar';

import styles from './StickyCalendar.module.css';

export const StickyCalendar = (props: BasicCalendarProps) => <BasicCalendar className={styles.stickyCalendar} {...props} />;
